let id = new Date().valueOf();
export function uid() {
    id += 1;
    return "temp://" + id;
}
export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
export function isSameId(firstId, secondId) {
    return firstId == secondId;
}
export function isObject(obj) {
    return obj !== null && typeof obj === "object" && !(obj instanceof Date);
}
export function isDefined(some) {
    return some !== null && some !== undefined;
}
export function isNull(obj) {
    return obj === null;
}
export function findIndex(arr, predicate) {
    const len = arr.length;
    for (let i = 0; i < len; i++) {
        if (predicate(arr[i])) {
            return i;
        }
    }
    return -1;
}
export function hasWhiteSpace(string) {
    return /\s/g.test(string);
}
export function isMacintosh() {
    return navigator.userAgent.indexOf("Mac") > -1;
}
export function getCloneObject(obj) {
    if (!obj)
        return obj;
    const clone = Array.isArray(obj) ? [] : {};
    for (const key in obj) {
        const value = obj[key];
        if (value instanceof Date) {
            clone[key] = new Date(value);
            continue;
        }
        clone[key] = typeof value === "object" ? getCloneObject(value) : value;
    }
    return clone;
}
export function flattenToTree(array) {
    const children = {};
    const tree = [];
    const map = {};
    for (let index = 0; index < array.length; index++) {
        map[array[index].id] = index;
        children[array[index].id] = [];
        array[index].children = [];
    }
    for (let index = 0; index < array.length; index++) {
        const task = array[index];
        if (task.parent && children[task.parent]) {
            array[map[task.parent]].children.push(task);
            children[task.parent].push(task);
        }
        else if (!isDefined(task.parent)) {
            tree.push(task);
        }
    }
    return tree;
}
export function treeToFlatten(array) {
    return array.flatMap(({ children, ...obj }) => [
        obj,
        ...treeToFlatten(children || []),
    ]);
}
//# sourceMappingURL=helpers.js.map